// extracted by mini-css-extract-plugin
export default {"buttonsGroup":"ChangeMovingDateModal_buttonsGroup__rMYZe"};